import { Layout, Row, Col } from "antd";
import { CopyrightOutlined, HeartTwoTone } from "@ant-design/icons";

function Footer() {
    const { Footer: AntFooter } = Layout;

    return (
        <AntFooter style={{ background: "#fafafa" }}>
            <Row>
                <Col xs={24} md={12} lg={24}>
                    <div className="copyright" style={{ marginRight: "2rem" }}>
                        {<CopyrightOutlined />}
                        &nbsp;2024, ساخته شده با
                        {<HeartTwoTone twoToneColor="#eb2f96" />}
                        <a href="https://hamareh.com" target="_blank ">
                            از شرکت هوشمند آرمان هماره.
                        </a>
                    </div>
                </Col>
            </Row>
        </AntFooter>
    );
}

export default Footer;
